/**
 * @typedef {'encabezado'|'portada'|'texto'|'division'|'filasDivididas'|'tarjetasImagen'|'lineaTiempo'|'acordeon'|'tarjetasAccion'|'carrusel'} SectionType
 */

/**
 * @typedef {'simple'|'cards'|'stats'|'split'|'accordion'} SectionLayout
 */

/**
 * @typedef {Object} EditorFieldConfig
 * @property {string} key
 * @property {string} label
 * @property {'text'|'textarea'|'select'} [input]
 * @property {string} [placeholder]
 * @property {{value:string,label:string}[]} [options]
 */

/**
 * @typedef {Object} SectionAdapter
 * @property {SectionType} type
 * @property {string} label - Display name (Spanish)
 * @property {SectionLayout} layout
 * @property {string[]} previewBlocks - Block labels for the editor preview
 * @property {function(import('./contentService').PageSection, number): JSX.Element|null} render
 * @property {string} [legacyType] - Old type name for migration
 * @property {function(): Object} [getDefaults] - Default section values
 * @property {EditorFieldConfig[]} [editorFields] - Fields for structured editor
 * @property {string} [itemLabel] - Singular label for items (e.g. "tarjeta")
 */

const registry = new Map();

/** @param {SectionAdapter} adapter */
export function registerSectionType(adapter) {
  registry.set(adapter.type, adapter);
}

/** @param {SectionType} type @returns {SectionAdapter|undefined} */
export function getSectionAdapter(type) {
  return registry.get(type);
}

/** @returns {SectionAdapter[]} */
export function getRegisteredAdapters() {
  return Array.from(registry.values());
}

/** @returns {{value:SectionType, label:string}[]} */
export function getSectionTypeOptions() {
  return getRegisteredAdapters()
    .filter((a) => a.type !== "division")
    .map((a) => ({ value: a.type, label: a.label }))
    .sort((a, b) => a.label.localeCompare(b.label, "es"));
}
